// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");
var ReactAriaComponents = require("react-aria-components");

function Form__Label(props) {
  var optionalText = props.optionalText;
  return JsxRuntime.jsxs(ReactAriaComponents.Label, {
              children: [
                JsxRuntime.jsx("span", {
                      children: props.labelText,
                      className: "mr-1 font-semibold text-base text-zinc-700"
                    }),
                optionalText !== undefined ? JsxRuntime.jsx("small", {
                        children: "(" + optionalText + ")",
                        className: "text-zinc-600"
                      }) : null
              ],
              htmlFor: props.htmlFor,
              className: "flex items-center leading-4 mb-2 flex-wrap"
            });
}

var make = Form__Label;

exports.make = make;
/* react/jsx-runtime Not a pure module */
